import COLOR_PALETTE from "../constants/colorPalette";

export const buildDepartmentStatsFromEmployees = (employees, totalOverride) => {
    const departmentCounts = new Map();

    employees.forEach((emp) => {
        const source =
            emp?.department?.name ??
            emp?.department ??
            emp?.departmentName ??
            emp?.department_name ??
            emp?.employeeType ??
            emp?.dept ??
            emp?.Team ??
            emp?.team ??
            emp?.position ??
            "Unassigned";

        const name = (() => {
            if (typeof source === "string") {
                const trimmed = source.trim();
                return trimmed.length ? trimmed : "Unassigned";
            }
            const value = String(source || "").trim();
            return value.length ? value : "Unassigned";
        })();

        departmentCounts.set(name, (departmentCounts.get(name) || 0) + 1);
    });

    const total = totalOverride ?? employees.length;

    return Array.from(departmentCounts.entries())
        .map(([name, count], index) => ({
            name,
            count,
            percentage: total > 0 ? Math.round((count / total) * 100) : 0,
            color: COLOR_PALETTE[index % COLOR_PALETTE.length],
        }))
        .filter((item) => item.count > 0);
};

export const mapDepartmentStatsResponse = (rawStats, totalEmployees) => {
    const candidates = (() => {
        if (!rawStats) return [];
        if (Array.isArray(rawStats)) return rawStats;
        if (Array.isArray(rawStats.data)) return rawStats.data;
        if (Array.isArray(rawStats.departments)) return rawStats.departments;
        if (Array.isArray(rawStats.stats)) return rawStats.stats;
        return [];
    })();

    if (!candidates.length) return [];

    const safeTotal = totalEmployees > 0 ? totalEmployees : candidates.reduce((sum, item) => {
        const count = Number(
            item.count ??
            item.total ??
            item.employeeCount ??
            item.employees ??
            item.value
        ) || 0;
        return sum + count;
    }, 0);

    return candidates
        .map((item, index) => {
            const count = Number(
                item.count ??
                item.total ??
                item.employeeCount ??
                item.employees ??
                item.value
            ) || 0;
            const name =
                item.name ??
                item.department ??
                item.departmentName ??
                item.label ??
                item.id ??
                "Unassigned";

            return {
                name,
                count,
                percentage: safeTotal > 0 ? Math.round((count / safeTotal) * 100) : 0,
                color: COLOR_PALETTE[index % COLOR_PALETTE.length],
            };
        })
        .filter((stat) => stat.count > 0);
};